<template>
    <div class="card">
        <div class="card-header">
            <div class="card-header-title">{{group.name}}</div>
        </div>
        <div class="card-content">
            <div class="content has-text-left">
                <div v-if="data.length > 0" class="container has-text-left">
                    <app-group-item
                            v-for="item in data"
                            :key="item.id"
                            :data="item"
                    ></app-group-item>
                </div>
                <div v-else>No objects.</div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import GroupItem from './GroupItem';

  export default {
    components: {
      appGroupItem: GroupItem
    },
    name: "card-for-group",
    props: ['group'],
    computed: {
      ...mapGetters('auth', ['hasPermission']),
      data() {
        return this.group.items;
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>
    .card-content {
        padding: 0.5rem;
    }

    .card_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.75rem;
        border-bottom: dotted 1px #C9C9C9;
        padding: 0 0.1rem 0.3rem 0.1rem;
        font-size: 0.85rem;
    }
</style>